import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/img/products/single-product-2.webp'
import _imports_1 from '../../../assets/img/icons/star.svg'
import _imports_2 from '../../../assets/img/icons/heart.svg'
import _imports_3 from '../../../assets/img/products/offer-2.webp'
import _imports_4 from '../../../assets/img/users/client.webp'


const _hoisted_1 = { class: "row ptb-100 align-items-center" }
const _hoisted_2 = { class: "col-lg-6" }
const _hoisted_3 = { class: "single-product-details" }
const _hoisted_4 = { class: "add-to-cart d-flex flex-wrap align-items-center" }
const _hoisted_5 = { class: "v-counter style-three bg_ash" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "tab-content product-tab-content" }
const _hoisted_8 = {
  class: "tab-pane fade show active",
  id: "tab_1",
  role: "tabpanel"
}
const _hoisted_9 = { class: "shop-desc row" }
const _hoisted_10 = { class: "col-lg-5" }
const _hoisted_11 = { class: "offer-card style-two" }
const _hoisted_12 = { class: "offer-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-lg-6" }, [
        _createElementVNode("div", { class: "single-product-item" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "Image"
          }),
          _createElementVNode("span", null, "New")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"d-flex align-items-center justify-content-between\" data-v-28b2271e><span class=\"fs-14 fw-semibold text-bg\" data-v-28b2271e>LAPTOP</span><div class=\"ratings d-flex align-items-center\" data-v-28b2271e><ul class=\"list-style d-flex lh-1\" data-v-28b2271e><li data-v-28b2271e><img src=\"" + _imports_1 + "\" alt=\"Image\" data-v-28b2271e></li><li data-v-28b2271e><img src=\"" + _imports_1 + "\" alt=\"Image\" data-v-28b2271e></li><li data-v-28b2271e><img src=\"" + _imports_1 + "\" alt=\"Image\" data-v-28b2271e></li><li data-v-28b2271e><img src=\"" + _imports_1 + "\" alt=\"Image\" data-v-28b2271e></li><li data-v-28b2271e><img src=\"" + _imports_1 + "\" alt=\"Image\" data-v-28b2271e></li></ul><span class=\"fs-14 text-bg lh-1 ms-2 mt-1\" data-v-28b2271e>4.9</span></div></div><h1 class=\"text-title fw-bold\" data-v-28b2271e>Sanung Laptop 14”, 8gb ram, 1tb ssd</h1><h3 class=\"product-price fw-bold text-green\" data-v-28b2271e>$3210.00</h3><p data-v-28b2271e> Your willingness to feel better will be your guide out of despair and joy. Feeling your feelings is essential to moving up the scale. </p>", 4)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                class: "plusBtn",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.increment && _ctx.increment(...args)))
              }),
              _createElementVNode("input", {
                type: "text",
                size: "25",
                value: _ctx.quantity,
                class: "count bg_ash"
              }, null, 8, _hoisted_6),
              _createElementVNode("button", {
                class: "minusBtn",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.decrement && _ctx.decrement(...args)))
              })
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("button", { class: "btn style-eleven" }, "Add To Cart", -1)),
            _cache[3] || (_cache[3] = _createElementVNode("button", { class: "btn style-tweleve" }, [
              _createTextVNode(" Add To Wishlist "),
              _createElementVNode("img", {
                src: _imports_2,
                alt: "Image"
              })
            ], -1))
          ]),
          _cache[5] || (_cache[5] = _createStaticVNode("<ul class=\"product-features list-style\" data-v-28b2271e><li class=\"text-bg fw-semibold fs-14\" data-v-28b2271e> SKU : <span class=\"fw-medium\" data-v-28b2271e>125J31</span></li><li class=\"text-bg fw-semibold fs-14\" data-v-28b2271e> CATEGORY : <span class=\"fw-medium\" data-v-28b2271e>Books, Happiness</span></li><li class=\"text-bg fw-semibold fs-14\" data-v-28b2271e> AVAILABILITY : <span class=\"fw-medium text-green\" data-v-28b2271e>instock</span></li></ul>", 1))
        ])
      ])
    ]),
    _cache[12] || (_cache[12] = _createElementVNode("ul", {
      class: "nav nav-tabs table-tablist mb-40",
      role: "tablist"
    }, [
      _createElementVNode("li", { class: "nav-item" }, [
        _createElementVNode("button", {
          class: "nav-link active",
          "data-bs-toggle": "tab",
          "data-bs-target": "#tab_1",
          type: "button",
          role: "tab"
        }, " Description ")
      ]),
      _createElementVNode("li", { class: "nav-item" }, [
        _createElementVNode("button", {
          class: "nav-link",
          "data-bs-toggle": "tab",
          "data-bs-target": "#tab_2",
          type: "button",
          role: "tab"
        }, " Reviews ")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "col-lg-7" }, [
            _createElementVNode("p", null, " Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus in magna ac tellus fringilla eleifend. Mauris et velit risus. Phasellus nisi ipsum, fermentum eget consequat non, molestie at augue. Proin rutrum sem a rutrum ultricies. "),
            _createElementVNode("p", null, " Nunc felis neque, dictum ut porta a, ullamcorper vel ante. Quisque non consequat ligula. Pellentesque porttitor eu nisi eu bibendum. In non faucibus justo, et viverra lectus. Fusce sodales mauris et velit accumsan vulputate. Lorem ipsum dolor sit ame. ")
          ], -1)),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "offer-img" }, [
                _createElementVNode("img", {
                  src: _imports_3,
                  alt: "Image"
                })
              ], -1)),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("h6", null, [
                  _createVNode(_component_router_link, { to: "/shop-right-sidebar" }, {
                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                      _createTextVNode(" Get ", -1),
                      _createElementVNode("span", null, "15%", -1),
                      _createTextVNode(" Cashback On Brand New Laptop ", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _createVNode(_component_router_link, {
                  to: "/shop-left-sidebar",
                  class: "btn style-two"
                }, {
                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createTextVNode(" Available Offer ", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _cache[11] || (_cache[11] = _createElementVNode("div", {
        class: "tab-pane fade",
        id: "tab_2",
        role: "tabpanel"
      }, [
        _createElementVNode("div", { class: "row" }, [
          _createElementVNode("div", { class: "col-lg-7" }, [
            _createElementVNode("div", { class: "client-reviews" }, [
              _createElementVNode("h6", { class: "fs-24 text-title mb-30" }, "01 Reviews"),
              _createElementVNode("div", { class: "review-item d-flex" }, [
                _createElementVNode("div", { class: "client-img" }, [
                  _createElementVNode("img", {
                    src: _imports_4,
                    alt: "Image"
                  })
                ]),
                _createElementVNode("div", { class: "review-info" }, [
                  _createElementVNode("div", { class: "d-flex flex-wrap justify-content-between align-items-center" }, [
                    _createElementVNode("h6", null, [
                      _createTextVNode("Jack Smith "),
                      _createElementVNode("span", null, "Sep 09, 2023 at 7:41 pm")
                    ]),
                    _createElementVNode("div", { class: "ratings d-flex align-items-center" }, [
                      _createElementVNode("ul", { class: "list-style d-flex lh-1" }, [
                        _createElementVNode("li", null, [
                          _createElementVNode("img", {
                            src: _imports_1,
                            alt: "Image"
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("img", {
                            src: _imports_1,
                            alt: "Image"
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("img", {
                            src: _imports_1,
                            alt: "Image"
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("img", {
                            src: _imports_1,
                            alt: "Image"
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("img", {
                            src: _imports_1,
                            alt: "Image"
                          })
                        ])
                      ]),
                      _createElementVNode("span", { class: "fs-14 text-bg lh-1 ms-2 mt-1" }, "4.9")
                    ])
                  ]),
                  _createElementVNode("p", { class: "mb-0" }, " Your willingness to feel better will be your guide out of despair and into joy. Feeling your feelings is essential to moving up the scale. Often when we’re stuck in an emotion, the reason we can’t get out of it is that we’re unwilling to acknowledge ")
                ])
              ]),
              _createElementVNode("div", { class: "review-item d-flex" }, [
                _createElementVNode("div", { class: "client-img" }, [
                  _createElementVNode("img", {
                    src: _imports_4,
                    alt: "Image"
                  })
                ]),
                _createElementVNode("div", { class: "review-info" }, [
                  _createElementVNode("div", { class: "d-flex flex-wrap justify-content-between align-items-center" }, [
                    _createElementVNode("h6", null, [
                      _createTextVNode("Alex Denver "),
                      _createElementVNode("span", null, "Sep 12, 2023 at 10:41 am")
                    ]),
                    _createElementVNode("div", { class: "ratings d-flex align-items-center" }, [
                      _createElementVNode("ul", { class: "list-style d-flex lh-1" }, [
                        _createElementVNode("li", null, [
                          _createElementVNode("img", {
                            src: _imports_1,
                            alt: "Image"
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("img", {
                            src: _imports_1,
                            alt: "Image"
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("img", {
                            src: _imports_1,
                            alt: "Image"
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("img", {
                            src: _imports_1,
                            alt: "Image"
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("img", {
                            src: _imports_1,
                            alt: "Image"
                          })
                        ])
                      ]),
                      _createElementVNode("span", { class: "fs-14 text-bg lh-1 ms-2 mt-1" }, "4.9")
                    ])
                  ]),
                  _createElementVNode("p", { class: "mb-0" }, " Your willingness to feel better will be your guide out of despair and into joy. Feeling your feelings is essential to moving up the scale. Often when we’re stuck in an emotion, the reason we can’t get out of it is that we’re unwilling to acknowledge ")
                ])
              ])
            ])
          ])
        ])
      ], -1))
    ])
  ], 64))
}